import Swiper from '../../common/custom-swiper/custom-swiper';

export default new class ProductTab {
  constructor() {
    this.linkTabSelector = 'tabs-content__link';
    this.activeLinkTabSelector = 'tabs-content__link__active';
    this.contentSelector = 'tabs-content__content';
    this.invisibleContentSelector = 'tabs-content__content_visually-hidden';

    this.sliderDocumentContainerSelector = 'tabs-content__tablist__container';
    this.slideDocumentSelector = 'tabs-content__tabitem';

    document.addEventListener('DOMContentLoaded', () => {
      this.initSlider();
      this.init();
    });
  }

  init() {
    $(document).on('click', `.${this.linkTabSelector}`, (e) => {
      e.preventDefault();

      const { target } = e;

      if ($(target).hasClass(this.activeLinkTabSelector)) return;

      this.showTab(target);
    });
  }

  hideTab() {
    const tabCollection = $(`.${this.linkTabSelector}`);
    const tabContentCollection = $(`.${this.contentSelector}`);

    [...tabCollection].forEach(tab => $(tab).removeClass(this.activeLinkTabSelector));
    [...tabContentCollection].forEach(el => $(el).addClass(this.invisibleContentSelector));
  }

  showTab(target) {
    const id = $(target).attr('href');
    const tabContent = $(id);

    this.hideTab();

    $(target).addClass(this.activeLinkTabSelector);

    tabContent.removeClass(this.invisibleContentSelector);
  }

  initSlider() {
    const sliderDocument = document.querySelector(`.${this.sliderDocumentContainerSelector}`);

    if (!sliderDocument) return;

    this.blogSlider = new Swiper(`.${this.sliderDocumentContainerSelector}`, {
      slidesPerView: 1.5,
      spaceBetween: 15,
      breakpointsInverse: true,
      watchOverflow: true,
      watchSlidesVisibility: true,
      watchSlidesProgress: true,
      observer: true,
      breakpoints: {
        880: {
          slidesPerView: 2.5,
        },
        1200: {
          slidesPerView: 3,
        },
      },
    });
  }
}();
